import React from 'react';

import { Link } from 'src/components/Inputs';

const SMSTerms = () => {
  return (
    <>
      <h4 id='sms-terms' data-magellan-target='sms-terms'>
        Plaid Short Message Service (SMS) Terms
      </h4>

      <p>Effective Date: December 1, 2023</p>
      <p>
        Plaid Inc. (“<strong>Plaid</strong>”) is a financial technology company
        that securely transfers your financial data from your bank to your apps.
        Plaid may send you Short Message Service (SMS) messages in order to
        provide a service to you and/or to confirm your identity by way of
        two-factor authentication. By agreeing to these SMS terms (“
        <strong>SMS Terms</strong>”), you consent to receive automated SMS
        messages from Plaid, and any of our SMS-related service providers (“
        <strong>service providers</strong>”), including through the use of an
        automatic telephone dialing system, at the telephone number you have
        provided. Message and data rates may apply. As a general matter, you
        will receive one message, per request. Carriers are not liable for
        delayed or undelivered messages.
      </p>
      <p>
        By agreeing to these SMS Terms, you authorize your wireless carrier to
        use or disclose information about your account and your wireless device,
        if available, to Plaid or our service provider for the duration of your
        business relationship, solely to help Plaid or our service provider
        identify you or your wireless device and to prevent fraud. Please see
        our{' '}
        <Link href='#end-user-privacy-policy'>
          <a>End User Privacy Policy</a>
        </Link>{' '}
        to see how we treat your data.
      </p>
      <p>
        The information your wireless carrier may disclose may include mobile
        number, name, address, email, network status, customer type, customer
        role, billing type, and mobile device identifiers (IMSI and IMEI). No
        mobile information will be shared with third parties or affiliates for
        marketing or promotional purposes. Text messaging originator opt-in data
        and consent information will not be shared with any third parties.
      </p>
      <p>
        If you do not wish to receive SMS messages from Plaid or our service
        providers, or if you no longer want your wireless operator to share
        information about you with Plaid or our service providers, you agree to
        reply STOP to any SMS message from Plaid or sent on behalf of Plaid in
        order to opt out of the SMS message notifications. You may receive an
        additional SMS message confirming your decision to opt out. After opting
        out of SMS messages, you will no longer receive messages from Plaid or
        our service providers unless you subsequently request SMS messages from
        us or sign up for any of our services, such as a Plaid Account, that
        require sending you SMS messages.
      </p>
      <p>
        If you are experiencing issues with the SMS messages from Plaid or our
        service providers, you can reply with the keyword HELP for more
        assistance, or you can visit{' '}
        <a href='https://my.plaid.com/help'>https://my.plaid.com/help</a>.
      </p>

      <hr className='section-divider' />
    </>
  );
};

export default SMSTerms;
